import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzNumFocalSize } from './sz-num-focal.types';

@Component({
  selector: 'sz-num-focal',
  templateUrl: './sz-num-focal.component.html',
  styleUrls: ['./sz-num-focal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzNumFocalComponent {
  readonly value: InputSignal<string | number> = input.required<string | number>();
  readonly unit: InputSignal<string | null> = input<string | null>(null);
  readonly size: InputSignal<SzNumFocalSize> = input<SzNumFocalSize>('lg');
}
